export default __webpack_public_path__ + "static/compact-mode-d2b4ea13ffc6c9e43a47793129380c8d.png";